export const isValidDate = (value) => {
    return value instanceof Date && !isNaN(value);
};